






















import { Component, Prop, Watch, Inject, Mixins } from 'vue-property-decorator';
import { AxiosInstance as ApiInstance } from 'axios';
import { remoteEduService } from '@/services';
import { MessageText } from './types';
import { Spinner as LoadingSpinner } from '@/components/spinners';
import { Message } from './components';
import { FileInputMixin } from '@/pages/profile/mixins';

@Component({
  components: {
    LoadingSpinner,
    Message,
    Form: () => import('@/pages/profile/blocks/form/Form.vue'),
    File: () => import('@/pages/profile/blocks/form/components/file'),
    Textarea: () => import('@/pages/profile/blocks/form/components/textarea'),
    Button: () => import('@/pages/profile/components/button'),
  },
})
export default class ResultForm extends Mixins(FileInputMixin) {
  @Inject() $api: ApiInstance;

  @Prop({ type: String, default: '' })
  readonly kidId!: string;

  @Prop({ type: String, default: '' })
  readonly testId!: string;

  @Prop({ type: String, default: '' })
  readonly scheduleId!: string;

  messageText = '';
  isLoading = false;
  isDisabled = true;
  resultForm: any = {};

  @Watch('resultForm.files.name')
  resultFileHandler(value: string) {
    if (value.length) {
      this.isDisabled = false;
    } else {
      this.isDisabled = true;
    }
  }

  @Watch('resultForm.text')
  resultTextHandler(value: string) {
    if (value.length) {
      this.isDisabled = false;
    } else {
      this.isDisabled = true;
    }
  }

  created() {
    this.setFormData();
  }

  async submitResultForm() {
    const { resultForm, $api } = this;
    const { files, ...formData } = resultForm;
    const data = !resultForm.files.name.length
      ? { ...formData }
      : { ...formData, 'files[]': resultForm.files, fileName: files.name };

    this.isLoading = true;
    try {
      const result = await remoteEduService($api).postRemoteEduTests(data);
      this.setFormData();
      this.isLoading = false;
      this.messageText = MessageText.SUCSSES;
    } catch (err) {
      // console.log(err);
      this.isLoading = false;
      this.messageText = MessageText.ERROR;
    }
  }

  setFormData() {
    const { kidId, testId, scheduleId } = this;
    this.resultForm = {
      files: { name: '' },
      text: '',
      kid_id: kidId,
      test_id: testId,
      schedule_id: scheduleId,
    };
  }

  closeMessage() {
    this.messageText = '';
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/components/info/components/block/components/resultform/ResulrForm.vue